<div class="security-restrictions-container">
    <div class="security-restrictions-container-row">
        <div class="security-restrictions-container-element">
            <div class="security-restrictions-element-label security-restriction-add-header">Add a security restriction
                <span id="addSecurityRestrictionsToolTipIcon"
                      class="infoIcon" calltoaction
                      [calltoactionTemplate]="securityRestrictionToolTipTemplateRef"></span>
            </div>

            <ng-template #securityRestrictionToolTipTemplateRef>
                <div>
                    <p>You can set restrictions that will apply to this security. This security will always follow this
                        rule, unless this setting is overridden on a portfolio or a portfolio's model.</p>
                    <p>You can choose from:</p>
                    <p><strong>Never sell</strong> - holdings of this security will be counted toward the portfolio's
                        allocation, but will never be sold.</p>
                    <p><strong>Never buy</strong> - If the security is in the portfolio model or listed as an alternate,
                        iRebal will not create a buy when this selection is made. If you select never buy, you must
                        select the action iRebal should take instead of buying the security.</p>
                    <p><strong>Never buy and never sell</strong> - If the security is in the portfolio model or listed
                        as an alternate, iRebal will not create a buy when this selection is made. This setting will be
                        counted toward the portfolio's allocation but will never be sold. You must select the action
                        iRebal should take instead of buying the security.</p>
                    <p><strong>Exclude</strong> - holdings of the security will not be counted toward the portfolio's
                        allocation, and will not be sold.</p>
                </div>
            </ng-template>
        </div>
    </div>
    <div class="security-restrictions-container-row">
        <div class="security-restrictions-container-element">
            <div class="security-restrictions-element-label">Restriction type</div>
            <div class="security-restrictions-element-input">
                <irb-dropdown-filter
                    #restrictionTypesDropdown
                    [(value)]="selectedRestrictionType"
                    [placeholder]="restrictionTypePlaceHolder"
                    (search)="getItemsForRestrictionTypesDropdown($event)"
                    (selection)="onRestrictionTypeChanged()"
                    size="30">
                </irb-dropdown-filter>

            </div>
        </div>
        <div class="security-restrictions-container-element">
            <div class="security-restrictions-element-label">Action to take</div>
            <div class="security-restrictions-element-input">
                <irb-dropdown-filter
                    #actionsToTakeDropdown
                    [(value)]="selectedActionToTake"
                    [placeholder]="restrictionActionToTakePlaceHolder"
                    [disabled]="!enableActionsToTake"
                    (search)="getItemsForActionsToTakeDropdown($event)"
                    (selection)="onActionToTakeChanged()"
                    size="30">
                </irb-dropdown-filter>


            </div>
        </div>
        <div class="security-restrictions-container-element security-restrictions-min-alt-dropdown">
            <div class="security-restrictions-element-label">Symbol</div>
            <div class="security-restrictions-element-input">
                <div [ngClass]="{'input-hilite': selectedActionToTake?.value === 'Buy an alternate security' && !selectedAltSecurity}" tooltip
                [tooltipTitle]="alternateSymbolTooltipMessage" tooltipPosition="bottom" tooltipClass="error">
                    <irb-dropdown-search
                        #alternativeSecuritiesDropdown
                        [(value)]="selectedAltSecurity"
                        [addNewItem]="addNewSecurityItem"
                        (openNewItemFlow)="openNewItemSecurityFlow($event)"
                        [placeholder]="alternateSecurityPlaceHolder"
                        [disabled]="!enableSecuritySymbol"
                        (search)="getItemsForAlternativeSecuritiesDropdown($event)"
                        (selection)="onAlternateSecuritySymbolChanged()"
                        size="30">
                    </irb-dropdown-search>
                </div>


            </div>

        </div>

    </div>
</div>

